var KeepAlive = (function () {
    var root = this;

    this.construct = function () {
        this.init();
    }

    this.init = function () {
        setInterval(refreshToken, (CONSTANTS.SESSION_LIFETIME / 2));

        function refreshToken() {
            $.get('/keep-alive').done(function() { });
        }
    }

    this.construct();
})();
